import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  LayoutDashboard, Package, Users, TrendingUp, LogOut
} from 'lucide-react';

const bottomNavItems = [
  { to: '/admin/dashboard', label: 'Home', icon: LayoutDashboard },
  { to: '/admin/products', label: 'Products', icon: Package },
  { to: '/admin/customers', label: 'Customers', icon: Users },
  { to: '/admin/sales', label: 'Sales', icon: TrendingUp },
];

function AdminBottomNav({ setIsAdmin }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    setIsAdmin(false);
    navigate('/admin');
  };

  return (
    <nav className="admin-bottom-nav">
      {bottomNavItems.map(item => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) => `admin-bottom-nav-item ${isActive ? 'active' : ''}`}
        >
          <item.icon size={20} />
          <span>{item.label}</span>
        </NavLink>
      ))}
      <button className="admin-bottom-nav-item logout" onClick={handleLogout}>
        <LogOut size={20} />
        <span>Logout</span>
      </button>
    </nav>
  );
}

export default AdminBottomNav;
